import type { ReactNode } from "react";
import styles from "./linkified-text.module.css";

const URL_PATTERN = /https?:\/\/[^\s<>"']+/gi;

export default function LinkifiedText({ text }: { text: string }) {
  const parts: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_PATTERN)) {
    const start = match.index ?? 0;
    if (start > lastIndex) parts.push(text.slice(lastIndex, start));

    const matched = match[0];
    const trailing = matched.match(/[.,!?;:)\]}]+$/)?.[0] ?? "";
    const candidate = matched.slice(0, matched.length - trailing.length);
    let valid = false;
    try {
      const url = new URL(candidate);
      valid = (url.protocol === "http:" || url.protocol === "https:") && Boolean(url.hostname);
    } catch { /* Keep incomplete URLs as text. */ }

    parts.push(valid
      ? <a key={start} className={styles.link} href={candidate} target="_blank" rel="noopener noreferrer">{candidate}</a>
      : candidate);
    if (trailing) parts.push(trailing);
    lastIndex = start + matched.length;
  }

  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return <>{parts}</>;
}
